import {startBugsnag, isBrowserSupported} from '../../common/init';

import {defineElement} from './shop-discount-auth';

/**
 * Initialize the discountApp web component.
 * This is the entry point that will be used for code-splitting.
 */
function init() {
  if (!isBrowserSupported()) return;
  startBugsnag();

  defineElement();
}

init();
